import _slicedToArray from "C:\\Users\\fgrassinger\\Documents\\Arbeitsprojekte\\InteractiveLegend_Matrix\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "C:\\Users\\fgrassinger\\Documents\\Arbeitsprojekte\\InteractiveLegend_Matrix\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import { entries, uniqueId } from './../../util';
import { SourceNode } from './source';
/**
 * Print debug information for dataflow tree.
 */

export function debug(node) {
  console.log("".concat(node.constructor.name).concat(node.debugName ? "(".concat(node.debugName, ")") : '', " -> ").concat(node.children.map(function (c) {
    return "".concat(c.constructor.name).concat(c.debugName ? " (".concat(c.debugName, ")") : '');
  })));
  console.log(node);
  node.children.forEach(debug);
}
/**
 * Print the dataflow tree as graphviz.
 *
 * Render the output in http://viz-js.com/.
 */

export function draw(roots) {
  // check the graph before printing it since the logic below assumes a consistent graph
  checkLinks(roots);
  var nodes = {};
  var edges = [];

  function getId(node) {
    var id = node['__uniqueid'];

    if (id === undefined) {
      id = uniqueId();
      node['__uniqueid'] = id;
    }

    return id;
  }

  function getLabel(node) {
    var out = [node.constructor.name.slice(0, -4)];

    if (node.debugName) {
      out.push("<i>".concat(node.debugName, "</i>"));
    } else if (node instanceof SourceNode) {
      if (node.data.name || node.data.url) {
        out.push("<i>".concat(node.data.name || node.data.url, "</i>"));
      }
    }

    var dep = node.dependentFields();

    if (dep.size) {
      out.push("<font color=\"grey\" point-size=\"10\">IN:</font> ".concat(_toConsumableArray(node.dependentFields()).join(', ')));
    }

    var prod = node.producedFields();

    if (prod.size) {
      out.push("<font color=\"grey\" point-size=\"10\">OUT:</font> ".concat(_toConsumableArray(node.producedFields()).join(', ')));
    }

    return out.join('<br/>');
  }

  function collector(node) {
    var id = getId(node);
    nodes[id] = {
      id: id,
      label: getLabel(node),
      hash: node instanceof SourceNode ? node.data.url || node.data.name || node.debugName : String(node.hash()).replace(/"/g, '')
    };
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = node.children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var child = _step.value;
        edges.push([id, getId(child)]);
        collector(child);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }

  roots.forEach(function (n) {
    return collector(n);
  });
  var dot = "digraph DataFlow {\n  rankdir = TB;\n  node [shape=record]\n  ".concat(entries(nodes).map(function (_ref) {
    var key = _ref.key,
        value = _ref.value;
    return "  \"".concat(key, "\" [\n    label = <").concat(value.label, ">;\n    tooltip = \"[").concat(value.id, "]&#010;").concat(value.hash, "\"\n  ]");
  }).join('\n'), "\n\n  ").concat(edges.map(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        source = _ref3[0],
        target = _ref3[1];

    return "\"".concat(source, "\" -> \"").concat(target, "\"");
  }).join(' '), "\n}");
  console.log(dot);
  return dot;
}
/**
 * Iterates over a dataflow graph and checks whether all links are consistent.
 */

export function checkLinks(nodes) {
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = nodes[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var node = _step2.value;
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = node.children[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var child = _step3.value;

          if (child.parent !== node) {
            console.error('Dataflow graph is inconsistent.', node, child);
            return false;
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      if (!checkLinks(node.children)) {
        return false;
      }
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return true;
}